import { render, staticRenderFns } from "./CustomerAutocomplete.vue?vue&type=template&id=5c5ee441&scoped=true"
import script from "./CustomerAutocomplete.vue?vue&type=script&lang=js"
export * from "./CustomerAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5ee441",
  null
  
)

export default component.exports